import type { City } from "@hermes/api";
import { createContext, useContext } from "react";

export const CityContext = createContext<{
  routeCity?: City;
  defaultCity: City;
  storedCity?: City;
  cities: City[];
  city: City;
  changeCityBySlug: (citySlug?: string, cityAreaSlug?: string) => void;
  resolveCityById: (id?: number) => City | undefined;
} | null>(null);

export const useCity = () => {
  const value = useContext(CityContext);

  if (!value) {
    throw new Error("useCity requires CityProvider");
  }

  return value;
};
